module.exports = __webpack_public_path__ + "img/contactBackgroundTopBack.d53c2008.svg";